import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "disabled", "size", "theme", "children", "icon", "onRemoveClick", "wrap"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTheme } from '@rescui/ui-contexts';
import { CloseIcon } from '@rescui/icons';
import styles from './removable-tag.p.module.css.js';

function getIconSize(size) {
  return size === 'xs' ? 's' : size;
}

var SIZE_STYLES = {
  xs: styles.sizeXs,
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};
var THEME_STYLES = {
  light: styles.themeLight,
  dark: styles.themeDark
};
var RemovableTag = /*#__PURE__*/React.forwardRef(function Tag(_ref, ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      themeFromProps = _ref.theme,
      children = _ref.children,
      icon = _ref.icon,
      _ref$onRemoveClick = _ref.onRemoveClick,
      onRemoveClick = _ref$onRemoveClick === void 0 ? function () {} : _ref$onRemoveClick,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme(themeFromProps);
  return /*#__PURE__*/React.createElement("span", _objectSpread(_objectSpread({
    className: cn(styles.wrapper, SIZE_STYLES[size], THEME_STYLES[theme], disabled && styles.disabled, wrap && styles.wrap, className),
    "data-test": 'removable-tag-wrapper'
  }, restProps), {}, {
    ref: ref
  }), /*#__PURE__*/React.isValidElement(icon) && /*#__PURE__*/cloneElement(icon, {
    className: cn(icon.props.className, styles.icon)
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.main,
    "data-test": "removable-tag"
  }, children), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "data-test": "removable-tag-remove-icon",
    className: styles.close,
    tabIndex: disabled ? -1 : 0,
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemoveClick();
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    size: getIconSize(size)
  })));
});
RemovableTag.propTypes = {
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 's', 'm', 'l']),
  theme: PropTypes.oneOf(['dark', 'light']),
  icon: PropTypes.node,
  onRemoveClick: PropTypes.func.isRequired
};
export { RemovableTag };
